import { render } from "./media-content.vue?vue&type=template&id=39923460"
import script from "./media-content.vue?vue&type=script&lang=js"
export * from "./media-content.vue?vue&type=script&lang=js"

import "./media-content.vue?vue&type=style&index=0&id=39923460&lang=scss"

import exportComponent from "/Users/ian/codebase/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__